<template>
  <div v-bind:class="{ 'panel-active': isActive, panel: true }">
    <h2 class="panel-header"><slot name="icon"></slot> {{ title }}</h2>
    <div class="panel-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Panel",
  props: {
    isActive: Boolean,
    title: String,
  },
  methods: {
    activatePanel() {
      this.isActive = true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.panel h2 {
  background-color: #f1f1f1;
  padding: 1rem;
}
.panel-content {
  max-height: 0;
  transition: max-height 0.15s ease-out;
  overflow: hidden;
}
.panel-active .panel-content {
  max-height: 99999px;
  transition: max-height 0.25s ease-in;
}
.panel-header svg {
  margin-right: 1rem;
}
</style>
